angular.module("locations")

    .controller("LocationsListCtrl", ['LoginService', 'treeService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$state',
        function (LoginService, treeService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate,$state) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("LOCATIONS_READ");

            $rootScope.title = $filter('translate')('locations.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('locations.title') }
            ];


            $scope.gridOptionsGroupLocations = {
                pdfTitle: $filter('translate')('materials_types.pdf_title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                expandAllRows: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [60, 80, 100],
                paginationPageSize: 60,
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    { name: 'name', displayName: $filter('translate')('materials_types.name'), enableFiltering: true, enableHiding: false },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('materials_types.button_edit'), action: 'ng-click="grid.appScope.goToEdit(row.entity);" ng-if="grid.appScope.allowWrite && row.entity.id != null"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('materials_types.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
                getData: function (options) {
                    var deferred = $q.defer();

                    Restangular.all('Locations').getList(options).then(function (result) {

                        result.unshift({
                            id: null,
                            name: null
                        });
                        var treeLocations = [];
                        var data = treeService.locationsTree(result, null, treeLocations);

                        deferred.resolve(data);
                    });
                    return deferred.promise;
                }
            };

            $scope.goToEdit = function (rowEntity) {
                $state.go("locations.edit", { id: rowEntity.id });
            }

            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('locations.button_delete'),
                    message: $filter('translate')('locations.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('Locations', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('locations.deleted_success'));
                            $scope.gridOptionsGroupLocations.gridApi.core.raise.itemDeleted($scope);
                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });

            };

        }])

;